<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  size: { type: String, default: "default" },
  class: { type: String, default: "" },
});

const sizeClasses = {
  sm: "h-4 w-4",
  default: "h-6 w-6",
  lg: "h-8 w-8",
};

const classes = computed(() =>
  cn(
    "animate-spin text-muted-foreground",
    sizeClasses[props.size] || sizeClasses.default,
    props.class
  )
);
</script>

<template>
  <svg
    :class="classes"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    />
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
</template>
